/* eslint-disable max-len */
import React, { SyntheticEvent, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import AssignBoxV2 from '../../component/dropdowns/assignPopup/assignPopupV2';
import AppLayout from '../../component/appLayout';
import {
  Buttons,
  Desc,
  HeaderInbox,
  InboxMSG,
  MSG,
  MSGdetail,
  MSGtime,
  Read,
  MSGtitle,
  MSGtext,
  MSGsubtext,
  MSGblock,
  MainHeader,
  IconView,
  AvatarDot,
  Icons,
  Bottom,
  BottomButton,
  BlankDiv,
  LeftSide,
  RightSide,
  Div,
  Heading,
  Title,
  Menu,
  SvgDiv,
  Empty,
  Header,
  CalendarDropdown,
  BottomDiv,
  ButtonsDiv,
  InputDiv,
  Inputs,
  InputLabel,
  InputValue,
  Input,
  Content,
  Overlay,
  InboxPreviewAction,
  ActionIcon,
  ActionSection,
  DetailPreview,
  PreviewSection,
  NotificationCard,
  DesktopIcon,
  Description,
  DesktopImage,
  RightContent,
  DateSection,
  ArrowIcon,
  MainItemDiv,
  ResponsiveSnoozeButton,
  SwipeRowContainer,
  SwipeAction,
  SwipeMsgCard,
  ItemDiv,
  NotificationIcon,
  Dropdiv
} from './styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteNotification,
  loadInboxData,
  updateNotification,
  clearAllNotifications
} from '../../services/inboxServices';
import moment from 'moment';
import {
  BUTTON_TYPE,
  COMMENT_TYPE,
  INBOX_FILTER_TYPE,
  NOTIFICATION_TYPE,
  ONESIGNAL_APP_ID,
  STATUS_TYPE
} from '../../global/constants';
import Avatar from '../../component/avatar/Avatar';
import { useHistory } from 'react-router-dom';
import {
  convertToUTCISO,
  formatToDateString,
  getCurrentDomain,
  getUrlParam,
  isElectronApp,
  isEmpty,
  renderStatusIconName
} from '../../helpers/common';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import UserPreferenceSingleton from '../../helpers/userPreferenceSingleton';
import { ROUTES } from '../../routes/urls';
import { initPushNotification } from '../../services/appService';
import RenderInboxHtml from '../../component/renderInbox';
import { captureException } from '../../services/logService';
import { CustomWindow } from '../../interfaces/OneSignalInterface';
import ModalCustom from '../../component/models/modal';
import DeleteModal from '../../component/models/deleteModel';
import { RootReducerInterface } from '../../interfaces/RootReducerInterface';
import InboxLoading from '../../component/loading/inboxLoading';
import EmptyState from '../../component/emptyState';
import inboxEmpty from '../../../src/assets/images/emptystates/inboxemptystate.svg';
import darkInboxEmpty from '../../../src/assets/images/emptystates/darkinboxempty.svg';
import { useMobileDevice } from '../../global/useMobile';
import TimePickerModal from '../../component/timePicker';
import dayjs from 'dayjs';
import { trackAnalyticActivity } from '../../services/analyticsService';
import { TASK_ANALYTICS } from '../../global/analyticsConstants';
import TaskDetailPreview from '../../component/models/taskDetailPreviewModal';
import desktopappmac from '../../assets/images/desktopapp-mac.png';
import { Dropdown, DropdownDivider, DropdownItem } from '../../component/Dropdown';
import { BottomNavigation } from '../../component/bottomNavigation';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { NotificationModel } from '../../mobx/models/notification';
import { useHotkeys } from 'react-hotkeys-hook';
import ResponsiveHeader from '../../component/responsiveHeader/header';
import { menuInboxArchiveItems, menuInboxFilterItems } from '../../global/row';
import { ProjectTemplateModel } from '../../mobx/models/projectTemplate';
import { ProjectModel } from '../../mobx/models/project';
import { TaskModel } from '../../mobx/models/task';
import { StatusListInterface } from '../../interfaces/ProjectInterface';
import { menuItems } from '../../helpers/list';
import { TaskGroupInterface } from '../../interfaces/TaskInterface';
import CalendarDropdownMenuV2 from '../../component/calendarPopUp/calendarDropdownMenuV2';
import { dispatchTaskUpdates, onUpdateStatus } from '../../services/taskActionService';
import ConfirmationModal from '../../component/models/confirmationModal';
import { updateTaskDetails } from '../../services/taskServices';
import { createNewComment } from '../../services/taskServices';
import CalendarcomponentV2 from '../../component/calendarPopUp/CalendarcomponentV2';
import ButtonV2 from '../../component/button/buttonV2';

declare const window: CustomWindow;
interface InboxProps {
  currentProject?: ProjectModel | ProjectTemplateModel;
  taskData: TaskModel;
  isRecurringTask: boolean;
  isTemplateProject: boolean;
}
const Inbox: React.FC<InboxProps> = ({ currentProject, taskData, isRecurringTask, isTemplateProject }) => {
  //Refs
  const buttonRef = useRef<React.RefObject<HTMLDivElement>[]>([]);
  const dropdownRefCalendar = useRef<HTMLDivElement | null>(null);
  const mobileDropdownTriggerRefs = useRef<React.RefObject<HTMLDivElement>[]>([]); // Ref for mobile dropdown triggers

  //States
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [overDueCardDismissed, setOverDueCardDismissed] = useState(false);
  const [notificationCardDismiss, setNotificationCardDismiss] = useState(false);
  const [desktopCardDismiss, setDesktopCardDismiss] = useState(false);
  const [deleteModelOpen, setDeleteModelOpen] = useState(false);
  const [permissionStatus, setPermissionStatus] = useState('');
  const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [position, setPosition] = useState<'top' | 'bottom'>('bottom');
  const [alignment, setAlignment] = useState<'left' | 'center' | 'right'>('left');
  const [dropdownTopOffset, setDropdownTopOffset] = useState<number>(0);
  const [buttonHeight, setButtonHeight] = useState<number>(0);
  const [selectedTime, setSelectedTime] = useState('00:00');
  const [selectedDate, setSelectedDate] = useState('');
  const [clientWindowHeight, setClientWindowHeight] = useState(0);
  const [isTaskDetailOpen, setIsTaskDetailOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState<NotificationModel | null>();
  const [selectedTaskIndex, setSelectedTaskIndex] = useState<number | null>();
  const [buttonDisable, setButtonDisable] = useState({
    forward: false,
    backward: false
  });
  const [hasMoved, setHasMoved] = useState(false);
  const [hoveredItemId, setHoveredItemId] = useState<string | null>(null);
  const [touchStartX, setTouchStartX] = useState<number | null>(null);
  const [touchEndX, setTouchEndX] = useState<number | null>(null);
  const [swipedItemId, setSwipedItemId] = useState<string | null>(null);
  const [status, setStatus] = useState<StatusListInterface | undefined>();
  const [previousStatus, setPreviousStatus] = useState<StatusListInterface | undefined>();
  const [currentTask, setCurrentTask] = useState<TaskModel | undefined>();
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState<string | null>(null);
  const [calanderDate, setCalendarDate] = useState(new Date());
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [swipeDirection, setSwipeDirection] = useState<'left' | 'right' | null>(null);
  const [deletingId, setDeletingId] = useState<string | null>(null);
  const [isRearranging, setIsRearranging] = useState(false);
  //use selector state variables
  const stateSelector = useSelector((state: RootReducerInterface) => state);
  const { settings: settingsSelector } = stateSelector || {};
  const { themeMode } = settingsSelector;

  //Mobx store variables
  const { notificationStore, workspaceStore, taskStore } = rootStore;
  const { notifications, filteredNotifications } = notificationStore;
  const { currentTask: taskDetails, overDueTasks } = taskStore;
  const { currentWorkspace } = workspaceStore;
  const workspace_id = currentWorkspace?.id || '';

  //Other variable
  const mobile = useMobileDevice();
  const getImageSource = () => (themeMode?.theme === 'dark' ? darkInboxEmpty : inboxEmpty);
  const dispatch = useDispatch();
  const history = useHistory();
  const filterType = Number(getUrlParam(history.location.search, 'type'));
  let isScrollPage: boolean;

  if (clientWindowHeight > 10) {
    isScrollPage = true;
  } else {
    isScrollPage = false;
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const snoozeMenuItems = [
    {
      key: 'today',
      iconName: 'today-snooze-icon',
      label: 'Today',
      RightSideLabel: moment().set({ hour: 15, minute: 0, second: 0 }).format('ddd, h:mm A')
    },
    {
      key: 'tomorrow',
      iconName: 'tomorrow-icon',
      label: 'Tomorrow',
      RightSideLabel: moment().add(1, 'days').set({ hour: 9, minute: 0, second: 0 }).format('ddd, h:mm A')
    },
    {
      key: 'this-Week',
      iconName: 'thisweek-snooze-icon',
      label: 'This Week'
    },
    {
      key: 'next-Week',
      iconName: 'next-week-icon',
      label: 'Next Week'
    }
  ];
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const overDueTime = UserPreferenceSingleton.getInstance().getOverDueRescheduleTime() || {};
  const notificationRescheduleTime = UserPreferenceSingleton.getInstance().getNotificationReschedule() || {};
  const deskTopNotificationRescheduleTime =
    UserPreferenceSingleton.getInstance().getDesktopNotificationReschedule() || '';
  const overDueRescheduleTime = overDueTime[workspace_id] || '';
  const isShowNotificationCard =
    (isEmpty(notificationRescheduleTime) ||
      (!isEmpty(notificationRescheduleTime) &&
        new Date(notificationRescheduleTime).getTime() <= new Date().getTime())) &&
    !notificationCardDismiss &&
    permissionStatus !== '' &&
    permissionStatus !== 'denied' &&
    permissionStatus !== 'granted' &&
    getCurrentDomain() === 'dash.teamcamp.app';

  const isShowDesktopNotification =
    !isElectronApp() &&
    !mobile &&
    !desktopCardDismiss &&
    (isEmpty(deskTopNotificationRescheduleTime) ||
      (!isEmpty(deskTopNotificationRescheduleTime) &&
        new Date(deskTopNotificationRescheduleTime).getTime() <= new Date().getTime()));
  const isShowOverdueCard =
    (isEmpty(overDueRescheduleTime) ||
      (!isEmpty(overDueRescheduleTime) && new Date(overDueRescheduleTime).getTime() <= new Date().getTime())) &&
    !overDueCardDismissed &&
    (overDueTasks || 0) > 0;

  // condition for calendar dropdown position set
  useEffect(() => {
    if (isCalendarOpen && dropdownRefCalendar?.current && buttonRef?.current) {
      // Check if openDropdownId is not null
      if (openDropdownId) {
        const index = filteredNotifications?.findIndex((item) => item?.id === openDropdownId);

        // Ensure the index is valid and that the reference exists
        if (index !== -1 && buttonRef?.current[index] && buttonRef?.current[index].current) {
          // Get rect for the active button
          const buttonRect = buttonRef?.current[index]?.current?.getBoundingClientRect();
          const buttonHeight = buttonRef?.current[index]?.current?.offsetHeight;
          const dropdownHeight = dropdownRefCalendar?.current?.offsetHeight;
          setButtonHeight(buttonHeight);

          // Calculate available space
          const spaceBelow = window.innerHeight - buttonRect.bottom;
          const spaceAbove = buttonRect.top;
          const spaceLeft = buttonRect.left;
          const spaceRight = window.innerWidth - buttonRect.right;
          // calculate dropdown width for alignment of dropdown
          const dropdownWidth = dropdownRefCalendar.current.offsetWidth;

          // check space below and above and then set position of the dropdown
          if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
            setPosition('top');
            setDropdownTopOffset(buttonRect.top - dropdownHeight);
          } else {
            setPosition('bottom');
            setDropdownTopOffset(buttonRect.top);
          }
          // check left & right space and then alignt the dropdown
          if (spaceLeft < dropdownWidth && spaceRight < dropdownWidth) {
            setAlignment('center');
          } else if (spaceRight < dropdownWidth) {
            setAlignment('right');
          } else {
            setAlignment('left');
          }
        }
      }
    }
  }, [alignment, dropdownTopOffset, isCalendarOpen, filteredNotifications, openDropdownId, position]);

  //light and dark mode github icon
  const getSvgIcon = useCallback(() => {
    return themeMode?.theme === 'dark' ? 'github-inbox-dark-icon' : 'github-inbox-light-icon';
  }, [themeMode?.theme]);

  // handle time change
  const handleTimeChange = useCallback((value: string) => {
    setSelectedTime(value);
  }, []);

  // open delete model
  const OpenDeleteModel = useCallback(() => {
    setDeleteModelOpen(true);
  }, []);

  // close delete model
  const closeDeleteModel = useCallback(() => {
    setDeleteModelOpen(false);
  }, []);

  // load initial data
  const loadData = useCallback(async () => {
    if (isEmpty(workspace_id)) return;
    try {
      setLoading(true);
      notificationStore.setFilterType(filterType);
      await dispatch(loadInboxData());
      const delayedTasks =
        rootStore?.currentUser?.tasks?.filter(
          (task) => task?.dueDate && moment(task.dueDate).startOf('day').isBefore(moment().startOf('day'))
        ) || [];
      rootStore.taskStore.setOverDueTasks(delayedTasks.length || 0);
    } catch (error) {
      captureException(error);
      console.log('error', error);
    } finally {
      setLoading(false);
    }
  }, [dispatch, filterType, notificationStore, workspace_id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  //handle inbox tab change
  const inboxTabChange = useCallback(
    (filterType: number) => {
      notificationStore.setFilterType(filterType);
      history.push(`${history.location.pathname}?type=${filterType}`);
    },
    [notificationStore, history]
  );

  // manage button dynamically
  const updateButtonState = useCallback((list: NotificationModel[], item: NotificationModel, taskIndex: number) => {
    const isValidTask = () =>
      [
        NOTIFICATION_TYPE.COMMENT,
        NOTIFICATION_TYPE.TASK,
        NOTIFICATION_TYPE.INVITE,
        NOTIFICATION_TYPE.PROJECT_INVITE
      ].includes(item?.type) &&
      item?.projectId &&
      item?.taskId;
    const hasForwardTask = list?.slice(taskIndex + 1).some(isValidTask);
    const hasBackwardTask = list?.slice(0, taskIndex).some(isValidTask);
    setButtonDisable({ forward: !hasForwardTask, backward: !hasBackwardTask });
  }, []);

  // redirect to task detail page
  const onClickInboxItem = useCallback(
    async (event: React.MouseEvent<HTMLDivElement>, notification: NotificationModel, index: number) => {
      if (!notification) return;
      const handleUpdateNotification = async () => {
        await dispatch(updateNotification(notification.id));
      };

      const handleMarkTaskAsRead = () => {
        notifications[index].markAsRead();
      };

      const trackViewAnalytics = () => {
        trackAnalyticActivity(TASK_ANALYTICS.VIEW, { source: 'inbox', title: notification?.description || '' });
      };

      const handleTaskDetailRedirection = () => {
        setIsTaskDetailOpen(true);
        setSelectedTask(notification);
        setSelectedTaskIndex(index);
        updateButtonState(filteredNotifications, notification, index);
      };

      const navigateToTaskDetails = () => {
        if (notification.projectId && notification.taskId) {
          rootStore.taskStore.setCurrentTask(notification.taskId);
          history.push(`/projects/details/${notification.projectId}/tasks/details/${notification.taskId}`);
        }
      };

      const navigateToProjectDetails = () => {
        if (notification.projectId) {
          rootStore.projectStore.setCurrentProject(notification.projectId);
          history.push(`/projects/details/${notification.projectId}/tasks`);
        }
      };

      const navigateToMessages = () => {
        const path = mobile
          ? `/messages/details?chatGroup=${notification.projectId}`
          : `/messages?chatGroup=${notification.projectId}`;
        history.push(path);
      };

      if (
        [
          NOTIFICATION_TYPE.COMMENT,
          NOTIFICATION_TYPE.TASK,
          NOTIFICATION_TYPE.INVITE,
          NOTIFICATION_TYPE.PROJECT_INVITE
        ].includes(notification.type)
      ) {
        await handleUpdateNotification();

        if (notification.projectId && notification.taskId) {
          if (!notification.isRead) {
            handleMarkTaskAsRead();
          }
          trackViewAnalytics();
          if (event.metaKey || event.ctrlKey) {
            handleTaskDetailRedirection();
          } else {
            navigateToTaskDetails();
          }
        } else if (notification.projectId && isEmpty(notification.companyId)) {
          if (notification.type === NOTIFICATION_TYPE.COMMENT) {
            navigateToMessages();
          } else {
            navigateToProjectDetails();
          }
        }
      }
    },
    [dispatch, history, mobile, filteredNotifications, notifications, updateButtonState]
  );

  // Helper function to reset swipe state
  const resetSwipe = useCallback(() => {
    setSwipedItemId(null);
    setSwipeDirection(null);
    setTouchStartX(null);
    setTouchEndX(null);
    setHasMoved(false);
  }, []);

  // manage read icon click
  const onClickReadIcon = useCallback(
    async (notification: { id: string; isRead: boolean }, index: number, e?: React.SyntheticEvent | undefined) => {
      e?.stopPropagation();
      // Reset swipe animation to work only in responsive screen
      if (mobile) resetSwipe();

      if (notification.isRead) return;
      notifications[index].markAsRead();
      await dispatch(updateNotification(notification?.id));
      setIsTaskDetailOpen(false);
    },
    [dispatch, mobile, notifications, resetSwipe]
  );

  // handle scroll
  const handleScroll = useCallback(() => {
    setClientWindowHeight(window.scrollY);
  }, []);

  // clear all notification
  const clearAllMessages = useCallback(async () => {
    try {
      setButtonLoading(true);
      const response = await dispatch(clearAllNotifications());
      if (response) {
        closeDeleteModel();
        rootStore.notificationStore.setNotifications([]);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setButtonLoading(false);
    }
  }, [closeDeleteModel, dispatch]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  useEffect(() => {
    initPushNotification();
  }, []);

  // get notification permission
  const getNotificationPermission = useCallback(async () => {
    window.OneSignal.push(function () {
      if (window.Notification?.permission) setPermissionStatus(window.Notification.permission);
    });
  }, []);

  // manage notification permission change
  const handlePermissionChange = useCallback((newPermission: { to: string }) => {
    if (newPermission?.to === 'default') UserPreferenceSingleton.getInstance().setOneSignalInit(false);
    setPermissionStatus(newPermission?.to);
  }, []);

  useEffect(() => {
    if (window.OneSignal) {
      window.OneSignal.push(() => {
        window.OneSignal.on('notificationPermissionChange', handlePermissionChange);
      });
      getNotificationPermission();
      return () => {
        window.OneSignal.push(() => {
          window.OneSignal.off('notificationPermissionChange', handlePermissionChange);
        });
      };
    } else {
      setPermissionStatus('denied');
    }
  }, [getNotificationPermission, handlePermissionChange]);

  // render icon for notification
  const renderProfileIcons = useCallback((type: number, title: string) => {
    const assignRegex = /Assigned you a task/i;
    const reopenRegex = /reopened a task/i;
    const completeRegex = /completed a task/i;
    const replyMessageRegex = /reply you/i;
    const assignIcon = assignRegex?.test(title);
    const reopenIcon = reopenRegex?.test(title);
    const completeIcon = completeRegex?.test(title);
    const replyMessageIcon = replyMessageRegex?.test(title);

    switch (type) {
      case NOTIFICATION_TYPE.TASK:
        if (assignIcon) {
          return (
            <NotificationIcon>
              <SVGIcon name='assign-task-icon' width='10' height='10' viewBox='0 0 18 18' />
            </NotificationIcon>
          );
        } else if (reopenIcon) {
          return (
            <NotificationIcon>
              <SVGIcon name='reopen-task-icon' width='10' height='10' viewBox='0 0 18 18' />
            </NotificationIcon>
          );
        } else if (completeIcon) {
          return (
            <NotificationIcon>
              <SVGIcon name='complate-task-icon' width='9' height='9' viewBox='0 0 18 18' />
            </NotificationIcon>
          );
        }
        break;
      case NOTIFICATION_TYPE.COMMENT:
        if (replyMessageIcon) {
          return (
            <NotificationIcon>
              <SVGIcon name='reply-message-icon' width='10' height='10' viewBox='0 0 18 18' />
            </NotificationIcon>
          );
        } else {
          return (
            <NotificationIcon>
              <SVGIcon name='mention-task-icon' width='10' height='10' viewBox='0 0 18 18' />
            </NotificationIcon>
          );
        }
      case NOTIFICATION_TYPE.PROJECT_INVITE:
      case NOTIFICATION_TYPE.INVITE:
        return (
          <NotificationIcon>
            <SVGIcon name='project-invited-icon' width='10' height='10' viewBox='0 0 18 18' />
          </NotificationIcon>
        );

      default:
        return <></>;
    }
  }, []);

  // for dismiss overdue card
  const onClickDismiss = useCallback(() => {
    const tomorrow = new Date();
    tomorrow.setDate(new Date().getDate() + 1);
    tomorrow.setHours(9, 0, 0, 0);
    const overDueTimeObject = {
      ...overDueTime,
      [workspace_id]: tomorrow.toISOString()
    };
    UserPreferenceSingleton.getInstance().setOverDueRescheduleTime(overDueTimeObject);
    setOverDueCardDismissed(true);
  }, [overDueTime, workspace_id]);

  // for enable notification overdue card
  const onEnableNotification = useCallback(async () => {
    try {
      window.OneSignal.push(function () {
        window.OneSignal.init({
          appId: ONESIGNAL_APP_ID
        });
      });
      window.OneSignal.push(function () {
        window.OneSignal.push(function () {
          window.OneSignal.push(['registerForPushNotifications']);
        });
      });
    } catch (e) {
      captureException(e);
    }
  }, []);

  // for disable (no enable) notification
  const onClickNoEnableNotification = useCallback(() => {
    const rescheduleDate = moment().add(1, 'weeks').toISOString();
    UserPreferenceSingleton.getInstance().setNotificationReschedule(rescheduleDate);
    setNotificationCardDismiss(true);
  }, []);

  // On click dismiss desktop notification
  const onDismissDesktopNotification = useCallback(() => {
    const rescheduleDate = moment().add(1, 'weeks').toISOString();
    UserPreferenceSingleton.getInstance().setDesktopNotificationReschedule(rescheduleDate);
    setDesktopCardDismiss(true);
  }, []);

  // render inbox card
  const renderCard = useCallback(
    ({
      iconName,
      title,
      text,
      buttonTitle,
      buttonAction,
      dismissAction,
      className
    }: {
      iconName: string;
      title: string;
      text: string;
      buttonTitle: string;
      buttonAction: () => void;
      dismissAction: () => void;
      className?: string;
    }) => {
      return (
        <MSG>
          <MSGdetail className={className}>
            <AvatarDot>
              <IconView className='pointer'>
                <BlankDiv></BlankDiv>
              </IconView>
              <SVGIcon name={iconName} width={`28px`} height={`28px`} viewBox={`0 0 28 28`} className='svg-icon' />
            </AvatarDot>
            <Read>
              <MSGtitle className={className}>{title}</MSGtitle>
              <MSGtext className={className}>{text}</MSGtext>
              <BottomButton>
                <ButtonV2 title={buttonTitle} variant={BUTTON_TYPE.SECONDARY} onClick={buttonAction} size='small' />
                <p onClick={dismissAction}>Dismiss</p>
              </BottomButton>
            </Read>
          </MSGdetail>
        </MSG>
      );
    },
    []
  );

  // Handle inbox card button click
  const handleClick = useCallback(
    async (key: string | number, notificationId: string) => {
      let payload;
      if (key === 'today') {
        payload = {
          snoozeDate: moment().set({ hour: 15, minute: 0, second: 0 }).toISOString()
        };
      } else if (key === 'this-Week') {
        payload = {
          snoozeDate: moment().endOf('week').set({ hour: 9, minute: 0, second: 0 }).toISOString()
        };
      } else if (key === 'tomorrow') {
        payload = {
          snoozeDate: moment().add(1, 'days').set({ hour: 9, minute: 0, second: 0 }).toISOString()
        };
      } else if (key === 'next-Week') {
        payload = {
          snoozeDate: moment()
            .clone()
            .day(8) // Set to next Monday
            .set({ hour: 9, minute: 0, second: 0 })
            .toISOString()
        };
      } else if (key === 'date-time') {
        setOpenDropdownId(notificationId);
        setIsCalendarOpen(true);
      }
      if (key !== 'date-time') {
        setOpenDropdownId(null);
      }
      let result;
      if (payload) {
        const currentTime = new Date().toISOString();

        if (payload?.snoozeDate < currentTime) {
          rootStore.alertNotificationStore.setErrorMessage('Please choose a date and time in the future.');
          return;
        }
        result = await dispatch(updateNotification(notificationId, payload));
      }
      if (result) {
        notificationStore.removeNotifications([notificationId]);
      }
    },
    [dispatch, notificationStore]
  );

  // handle click of snooze icon
  const onClickSnooze = useCallback(async () => {
    if (isEmpty(selectedDate)) {
      rootStore.alertNotificationStore.setErrorMessage('Please select a date.');
      return;
    }
    if (!openDropdownId) return;
    const finalCombinedDate = convertToUTCISO(selectedDate, selectedTime);

    // Check if the final date is valid
    if (!finalCombinedDate || isNaN(new Date(finalCombinedDate).getTime())) {
      rootStore.alertNotificationStore.setErrorMessage('Invalid final date.');
      return;
    }

    const currentTime = new Date().toISOString();

    if (finalCombinedDate < currentTime) {
      rootStore.alertNotificationStore.setErrorMessage('Please choose a date and time in the future.');
      return;
    }

    const result = await dispatch(updateNotification(openDropdownId, { snoozeDate: finalCombinedDate }));
    if (result) {
      setIsCalendarOpen(false);
      setOpenDropdownId(null);
      rootStore.alertNotificationStore.setSuccessMessage('Notification snoozed successfully.');
      notificationStore.removeNotifications([openDropdownId]);
      setSelectedDate('');
      setSelectedTime('00:00');
      setIsTaskDetailOpen(false);
    }
  }, [dispatch, notificationStore, openDropdownId, selectedDate, selectedTime]);

  // handle dropdown close on outside click
  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (dropdownRefCalendar.current && !dropdownRefCalendar.current.contains(event.target as Node)) {
      setIsCalendarOpen(false); // Close dropdown on outside click
      setOpenDropdownId(null);
    }
  }, []);
  useEffect(() => {
    if (isCalendarOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside, isCalendarOpen]);

  //  handle cancel snooze
  const onCancelSnooze = useCallback(() => {
    setIsCalendarOpen(false);
    setSelectedDate('');
    setSelectedTime('00:00');
    // setOpenDropdownId(null);
  }, []);

  // handle close task detail
  const handleCloseTaskDetail = () => {
    setIsTaskDetailOpen(false);
    setSelectedTask(null);
    setSelectedTaskIndex(null);
  };

  // handle next notification for go to next notification
  const handleNextNotificationOriginal = useCallback(
    (list?: NotificationModel[]) => {
      // Find the next valid task after the current task index
      if (!selectedTaskIndex && selectedTaskIndex !== 0) return;
      const notificationList = list || filteredNotifications || [];
      const nextTask = filteredNotifications
        ?.slice(selectedTaskIndex + 1)
        .find(
          (task) =>
            (task?.type === NOTIFICATION_TYPE.COMMENT ||
              task?.type === NOTIFICATION_TYPE.TASK ||
              task?.type === NOTIFICATION_TYPE.INVITE ||
              task?.type === NOTIFICATION_TYPE.PROJECT_INVITE) &&
            task?.projectId &&
            task?.taskId
        );
      if (nextTask) {
        const nextTaskIndex = notificationList?.findIndex((task) => task?.id === nextTask?.id);
        setSelectedTask(nextTask);
        setSelectedTaskIndex(nextTaskIndex);
        updateButtonState(notificationList, nextTask, nextTaskIndex);
      }
    },
    [filteredNotifications, selectedTaskIndex, updateButtonState]
  );

  // handle previous notification for go to previous notification
  const handlePreviousNotificationOriginal = useCallback(
    (list?: NotificationModel[]) => {
      // Find the previous valid task before the current task index
      if (!selectedTaskIndex && selectedTaskIndex !== 0) return;
      const notificationList = list || filteredNotifications || [];
      const previousTask = [...filteredNotifications]
        ?.slice(0, selectedTaskIndex)
        .reverse()
        .find(
          (task) =>
            (task?.type === NOTIFICATION_TYPE.COMMENT ||
              task?.type === NOTIFICATION_TYPE.TASK ||
              task?.type === NOTIFICATION_TYPE.INVITE ||
              task?.type === NOTIFICATION_TYPE.PROJECT_INVITE) &&
            task?.projectId &&
            task?.taskId
        );
      if (previousTask) {
        const previousTaskIndex = notificationList?.findIndex((task) => task?.id === previousTask?.id);
        setSelectedTask(previousTask);
        setSelectedTaskIndex(previousTaskIndex);
        updateButtonState(notificationList, previousTask, previousTaskIndex);
      }
    },
    [filteredNotifications, selectedTaskIndex, updateButtonState]
  );

  // Wrap the original functions with animation control
  const handleNextNotification = useCallback(
    (updatedList = filteredNotifications) => {
      setIsRearranging(true);
      // Add a slight delay to ensure state update before navigation
      setTimeout(() => {
        handleNextNotificationOriginal(updatedList);
        // Reset the flag after navigation
        setTimeout(() => setIsRearranging(false), 50);
      }, 20);
    },
    [handleNextNotificationOriginal, filteredNotifications]
  );

  const handlePreviousNotification = useCallback(
    (updatedList = filteredNotifications) => {
      setIsRearranging(true);
      // Add a slight delay to ensure state update before navigation
      setTimeout(() => {
        handlePreviousNotificationOriginal(updatedList);
        // Reset the flag after navigation
        setTimeout(() => setIsRearranging(false), 50);
      }, 20);
    },
    [handlePreviousNotificationOriginal, filteredNotifications]
  );

  // handle arrow click for forward and backward
  const handleArrowClick = useCallback(
    (type: string) => {
      if (
        (selectedTaskIndex || selectedTaskIndex === 0) &&
        selectedTaskIndex !== filteredNotifications?.length - 1 &&
        type === 'Forward'
      ) {
        handleNextNotification();
      } else if (selectedTaskIndex && selectedTaskIndex !== 0 && type === 'Backward') {
        handlePreviousNotification();
      }
    },
    [handleNextNotification, handlePreviousNotification, filteredNotifications, selectedTaskIndex]
  );

  // handle delete icon click
  const onClickDeleteIcon = useCallback(
    async (notification: { id: string; isRead: boolean }, e?: React.SyntheticEvent | undefined) => {
      e?.stopPropagation();

      if (mobile) {
        setDeletingId(notification.id); // Start animation
        // Reset swipe animation to work only in responsive screen
        resetSwipe();
        // for animtaion in responsive screen  added setTimeOut
        setTimeout(async () => {
          let updatedList = [...filteredNotifications];
          const indexOfNotificationToRemove = updatedList.findIndex((item) => item.id === notification.id);
          if (indexOfNotificationToRemove !== -1) {
            updatedList.splice(indexOfNotificationToRemove, 1);
            notificationStore.removeNotifications([notification.id]);
          }
          if (buttonDisable.forward && buttonDisable.backward) {
            setIsTaskDetailOpen(false);
          } else if (buttonDisable.forward) {
            handlePreviousNotification(updatedList);
          } else {
            handleNextNotification(updatedList);
          }
          await dispatch(deleteNotification(notification?.id));
          setDeletingId(null);
        }, 200); // Animation duration
      } else {
        // Desktop: delete immediately, no animation
        let updatedList = [...filteredNotifications];
        const indexOfNotificationToRemove = updatedList.findIndex((item) => item.id === notification.id);
        if (indexOfNotificationToRemove !== -1) {
          updatedList.splice(indexOfNotificationToRemove, 1);
          notificationStore.removeNotifications([notification.id]);
        }
        if (buttonDisable.forward && buttonDisable.backward) {
          setIsTaskDetailOpen(false);
        } else if (buttonDisable.forward) {
          handlePreviousNotification(updatedList);
        } else {
          handleNextNotification(updatedList);
        }
        await dispatch(deleteNotification(notification?.id));
      }
    },
    [
      resetSwipe,
      mobile,
      filteredNotifications,
      buttonDisable.forward,
      buttonDisable.backward,
      dispatch,
      notificationStore,
      handlePreviousNotification,
      handleNextNotification
    ]
  );

  const onClickSnoozeIcon = useCallback(
    (id: string) => {
      // Reset swipe animation to work only in responsive screen
      if (mobile) resetSwipe(); // Always reset swipe state when opening snooze dropdown
      setOpenDropdownId(id);
    },
    [mobile, resetSwipe]
  );

  // Render inbox button
  const renderInboxButton = useCallback(
    (item: NotificationModel, index: number, isTaskDetailPreview: boolean) => {
      return (
        <Icons className='inbox-icons' isTaskDetailPreview={isTaskDetailPreview}>
          <SvgDiv onClick={(e) => onClickReadIcon(item, index, e)} isTaskDetailPreview={isTaskDetailPreview}>
            <SVGIcon name='true-icon' width='16' height='16' viewBox='0 0 16 16' className='icons' />
          </SvgDiv>

          {/* Snooze Dropdown */}
          <Dropdown
            modalTitle='Snooze'
            isRemoveMaxHeight={true}
            isMinWidth={218}
            allowOutsideScroll={isCalendarOpen}
            disablePositionChangeOnScroll={true}
            content={
              <SvgDiv
                isTaskDetailPreview={isTaskDetailPreview}
                onClick={() => {
                  onClickSnoozeIcon(item?.id);
                }}>
                <SVGIcon name='snooze-icon' width='16' height='16' viewBox='0 0 16 16' className='icon' />
              </SvgDiv>
            }
            trigger='click'
            onOutsideClick={() => {
              setIsCalendarOpen(false);
              setOpenDropdownId(null);
            }}>
            {!isCalendarOpen &&
              snoozeMenuItems.map((dropdownItem) => (
                <DropdownItem
                  key={dropdownItem.key}
                  label={dropdownItem.label}
                  iconName={dropdownItem.iconName}
                  iconSize={16}
                  iconViewBox='0 0 24 24'
                  isSuffix={dropdownItem.RightSideLabel}
                  onClick={() => handleClick(dropdownItem.key, item.id)}
                  isSnoozeDropdown={true}
                />
              ))}
            {!isCalendarOpen && <DropdownDivider />}
            {/* Date & Time Sub-dropdown */}
            {!isCalendarOpen && (
              <MainItemDiv>
                <DropdownItem
                  key='date-time'
                  label='Date & Time'
                  onClick={(e) => {
                    e?.stopPropagation(); // Prevent outer dropdown close
                    setIsCalendarOpen(true); // Explicitly set to true
                    setOpenDropdownId(item.id); // Ensure calendar knows which item it's for
                  }}
                  isSuffix={true}
                />
              </MainItemDiv>
            )}

            {isCalendarOpen && openDropdownId === item.id && (
              <CalendarDropdown
                ref={dropdownRefCalendar}
                onClick={(e) => e.stopPropagation()} // Prevent outer dropdown close
                buttonHeight={buttonHeight}
                direction={position}
                alignment={alignment}
                dropdownTopOffset={dropdownTopOffset}
                className='reference-item'>
                <Header>
                  <ArrowIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsCalendarOpen(false); // Close only calendar
                    }}>
                    <SVGIcon
                      name='left-arrow-icon'
                      width='18'
                      height='18'
                      viewBox='0 0 16 16'
                      fill='none'
                      className='arrow-icon'
                    />
                  </ArrowIcon>
                  <p>Snooze</p>
                </Header>
                <div style={{ placeItems: 'center', padding: '0 8px 10px' }}>
                  <CalendarcomponentV2
                    isInbox={true}
                    setCalendarDate={(date) => setSelectedDate(formatToDateString(date.toISOString()))}
                  />
                </div>
                <BottomDiv>
                  <InputDiv>
                    <Inputs>
                      <InputLabel>Date</InputLabel>
                      <InputValue type='text' placeholder='DD/MM/YY' value={selectedDate} disabled />
                    </Inputs>
                    <Inputs>
                      <InputLabel>Time</InputLabel>
                      <Input onClick={(e) => e.stopPropagation()}>
                        <TimePickerModal
                          value={dayjs(selectedTime, 'HH:mm')}
                          onSelect={(value) => handleTimeChange(value.format('HH:mm'))}
                          style={{ width: '100%', height: '24px' }}
                        />
                      </Input>
                    </Inputs>
                  </InputDiv>
                  <ButtonsDiv>
                    <ButtonV2
                      title='Cancel'
                      variant={BUTTON_TYPE.SECONDARY}
                      className='button'
                      onClick={(e: SyntheticEvent) => {
                        e.stopPropagation();
                        onCancelSnooze();
                      }}
                    />
                    <ButtonV2
                      title='Snooze'
                      variant={BUTTON_TYPE.PRIMARY}
                      className='button'
                      onClick={(e: SyntheticEvent) => {
                        e.stopPropagation();
                        onClickSnooze();
                      }}
                    />
                  </ButtonsDiv>
                </BottomDiv>
              </CalendarDropdown>
            )}
          </Dropdown>

          {/* Delete Icon */}
          <SvgDiv onClick={(e) => onClickDeleteIcon(item, e)} isTaskDetailPreview={isTaskDetailPreview}>
            <SVGIcon name='bin-icon' width='16' height='16' viewBox='0 0 16 16' className='icons' />
          </SvgDiv>
        </Icons>
      );
    },
    [
      isCalendarOpen,
      snoozeMenuItems,
      openDropdownId,
      buttonHeight,
      position,
      alignment,
      dropdownTopOffset,
      selectedDate,
      selectedTime,
      onClickReadIcon,
      onClickSnoozeIcon,
      handleClick,
      handleTimeChange,
      onCancelSnooze,
      onClickSnooze,
      onClickDeleteIcon
    ]
  );

  useHotkeys(
    'e',
    (e) => {
      if (hoveredItemId) {
        const item = filteredNotifications?.find((notification) => notification.id === hoveredItemId);
        if (item) {
          onClickDeleteIcon(item);
        }
      }
    },
    { enabled: !!hoveredItemId }
  );

  // Add these handlers after the existing handlers
  const handleTouchStart = useCallback(
    (e: React.TouchEvent, itemId: string) => {
      if (!mobile) return;

      // Reset any previous swipe state first to prevent interference
      if (swipedItemId && swipedItemId !== itemId) {
        resetSwipe();
      }
      setTouchStartX(e.touches[0].clientX);
      setSwipedItemId(itemId);
      setSwipeDirection(null); // Reset direction on new touch
    },
    [mobile, swipedItemId, resetSwipe]
  );

  const handleTouchMove = useCallback(
    (e: React.TouchEvent) => {
      if (!mobile || !touchStartX || !swipedItemId) return;

      const currentX = e.touches[0].clientX;
      // Calculate how far finger has moved from start position
      const diff = touchStartX - currentX;

      if (Math.abs(diff) > 0) {
        e.preventDefault(); // 🔒 prevent page scroll when horizontal movement detected
      }

      setTouchEndX(currentX);
      // Update direction based on movement direction
      if (diff > 0) {
        setSwipeDirection('left');
      }
    },
    [mobile, touchStartX, swipedItemId]
  );

  const handleTouchEnd = useCallback(
    (e: React.TouchEvent) => {
      if (!mobile || !touchStartX || !touchEndX || !swipedItemId) return;
      // Calculate swipe distance
      const diff = touchStartX - touchEndX;
      const threshold = 146; // Minimum swipe distance to trigger action

      if (Math.abs(diff) < threshold) {
        // Didn't swipe far enough - reset immediately
        resetSwipe();
      } else if (diff >= threshold) {
        // Left swipe beyond threshold - keep at swipe position
        setSwipeDirection('left');
        // Don't reset the swipe to allow the user to click on buttons
      } else if (diff < 0) {
        // Tried to swipe right - reset immediately
        resetSwipe();
      }
    },
    [mobile, touchStartX, touchEndX, resetSwipe, swipedItemId]
  );

  const checkSubtaskStatus = useCallback((task: TaskModel) => {
    let allSubTasksStatus = true;
    if (task?.subTasks && task?.subTasks?.length > 0) {
      for (const subTask of task.subTasks) {
        if (subTask?.status === false) {
          allSubTasksStatus = false;
          break;
        }
      }
    }
    return allSubTasksStatus;
  }, []);

  const handleOpenConfirmationModal = useCallback(() => {
    setIsOpenConfirmationModal(true);
  }, []);

  const onClickUpdateStatus = useCallback(
    (task: TaskModel, status: StatusListInterface, previousStatus: StatusListInterface) => {
      const isSubtaskRemaining = checkSubtaskStatus(task);
      if (status.Type === STATUS_TYPE.COMPLETED && !isSubtaskRemaining) {
        handleOpenConfirmationModal();
        setStatus(status);
        setPreviousStatus(previousStatus);
        setCurrentTask(task);
        return;
      }
      onUpdateStatus(task, status, previousStatus, false, dispatch);
    },
    [checkSubtaskStatus, dispatch, handleOpenConfirmationModal]
  );

  const closeConfirmationModal = useCallback(() => {
    setIsOpenConfirmationModal(false);
  }, []);

  //Handle Yes button click for confirmation model
  const onClickConfirm = useCallback(() => {
    if (!currentTask) return;
    try {
      setConfirmationLoading('ok');
      if (currentTask.project?.statusEnable && status && previousStatus) {
        onUpdateStatus(currentTask, status, previousStatus, true, dispatch);
      } else {
        currentTask.setStatus(true, true);
        dispatchTaskUpdates(currentTask, true, dispatch);
        loadData?.();
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setConfirmationLoading(null);
      closeConfirmationModal();
    }
  }, [closeConfirmationModal, currentTask, dispatch, loadData, previousStatus, status]);

  //Handle No button click for confirmation model
  const onClickNo = useCallback(() => {
    if (!currentTask) return;
    try {
      setConfirmationLoading('cancel');
      if (currentTask.project?.statusEnable && status && previousStatus) {
        onUpdateStatus(currentTask, status, previousStatus, false, dispatch);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setConfirmationLoading(null);
      closeConfirmationModal();
    }
  }, [closeConfirmationModal, currentTask, dispatch, previousStatus, status]);

  const onClickUpdatePriority = useCallback(
    async (task: TaskModel, key: number) => {
      const previousPriority = task?.priority;
      task.setPriority(key);
      const payloadTask = { priority: Number(key), projectId: task?.projectId };
      const result = await dispatch(updateTaskDetails(task?.id, payloadTask));
      const commentResult = await dispatch(
        createNewComment(task?.id, {
          Type: COMMENT_TYPE.CHANGE_PRIORITY,
          PreviousPriority: previousPriority,
          Priority: Number(key)
        })
      );
      if (result && commentResult) {
        trackAnalyticActivity(TASK_ANALYTICS.PRIORITY_CHANGED);
      }
    },
    [dispatch]
  );

  const onClickGroup = useCallback(
    async (tasks: TaskModel, group: TaskGroupInterface) => {
      const previousGroup = currentProject?.taskGroups?.find((x) => x?.id === tasks?.groupId);
      const payloadTask = { groupId: group?.id, projectId: tasks?.projectId };
      const result = await dispatch(updateTaskDetails(tasks?.id, payloadTask));
      const commentResult = await dispatch(
        createNewComment(tasks?.id, {
          Type: COMMENT_TYPE.CHANGE_GROUP,
          PreviousGroup: previousGroup?.name,
          Group: group?.name
        })
      );
      if (result && commentResult) {
        tasks?.setGroup(group?.id);
        trackAnalyticActivity(TASK_ANALYTICS.GROUP_CHANGED);
      }
    },
    [currentProject?.taskGroups, dispatch]
  );

  const renderSnoozeDropdown = useCallback(
    (item: NotificationModel, isContextMenu: boolean) => {
      return (
        <>
          <Dropdown
            modalTitle='Snooze'
            content={
              isContextMenu ? (
                <DropdownItem label='Reschedule' iconName='snooze-icon' />
              ) : (
                <ResponsiveSnoozeButton>
                  <SVGIcon name='snooze-icon' width='16' height='16' viewBox='0 0 16 16' className='snooze-icon' />
                  <div className='snooze-text'>Snooze</div>
                </ResponsiveSnoozeButton>
              )
            }
            trigger='click' // Nested trigger
            onOutsideClick={() => {
              setIsCalendarOpen(false);
            }}
            isRemoveMaxHeight={true}
            isMinWidth={218} // Match desktop snooze width
          >
            {!isCalendarOpen &&
              snoozeMenuItems.map((dropdownItem) => (
                <DropdownItem
                  key={dropdownItem.key}
                  label={dropdownItem.label}
                  iconName={dropdownItem.iconName}
                  iconSize={16}
                  iconViewBox='0 0 24 24'
                  isSuffix={dropdownItem.RightSideLabel}
                  isSnoozeDropdown={true}
                  onClick={(e) => {
                    e?.stopPropagation(); // Prevent outer dropdown close
                    handleClick(dropdownItem.key, item.id);
                  }}
                />
              ))}
            {!isCalendarOpen && <DropdownDivider />}
            {!isCalendarOpen && (
              <MainItemDiv>
                <DropdownItem
                  key='date-time'
                  label='Date & Time'
                  onClick={(e) => {
                    e?.stopPropagation(); // Prevent outer dropdown close
                    setIsCalendarOpen((prev) => !prev);
                    setOpenDropdownId(item.id); // Ensure calendar knows which item it's for
                  }}
                  isSuffix={true}
                />
              </MainItemDiv>
            )}
            {/* Calendar - Render conditionally based on isCalendarOpen and correct openDropdownId */}
            {isCalendarOpen && openDropdownId === item.id && (
              <CalendarDropdown
                ref={dropdownRefCalendar}
                onClick={(e) => e.stopPropagation()} // Prevent outer dropdown close
                buttonHeight={buttonHeight}
                direction={position}
                alignment={alignment}
                dropdownTopOffset={dropdownTopOffset}
                className='reference-item'>
                <Header>
                  <ArrowIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsCalendarOpen(false); // Close only calendar
                    }}>
                    <SVGIcon
                      name='left-arrow-icon'
                      width='18'
                      height='18'
                      viewBox='0 0 16 16'
                      fill='none'
                      className='arrow-icon'
                    />
                  </ArrowIcon>
                  <p>Snooze</p>
                </Header>
                <div style={{ placeItems: 'center', padding: '0 8px 10px' }}>
                  <CalendarcomponentV2
                    isInbox={true}
                    setCalendarDate={(date) => setSelectedDate(formatToDateString(date.toISOString()))}
                  />
                </div>
                <BottomDiv>
                  <InputDiv>
                    <Inputs>
                      <InputLabel>Date</InputLabel>
                      <InputValue type='text' placeholder='DD/MM/YY' value={selectedDate} disabled />
                    </Inputs>
                    <Inputs>
                      <InputLabel>Time</InputLabel>
                      <Input onClick={(e) => e.stopPropagation()}>
                        <TimePickerModal
                          value={dayjs(selectedTime, 'HH:mm')}
                          onSelect={(value) => handleTimeChange(value.format('HH:mm'))}
                          style={{ width: '100%', height: '24px' }}
                        />
                      </Input>
                    </Inputs>
                  </InputDiv>
                  <ButtonsDiv>
                    <ButtonV2
                      title='Cancel'
                      variant={BUTTON_TYPE.SECONDARY}
                      className='button'
                      onClick={(e: SyntheticEvent) => {
                        e.stopPropagation();
                        onCancelSnooze();
                      }}
                    />
                    <ButtonV2
                      title='Snooze'
                      variant={BUTTON_TYPE.PRIMARY}
                      className='button'
                      onClick={(e: SyntheticEvent) => {
                        e.stopPropagation();
                        onClickSnooze();
                      }}
                    />
                  </ButtonsDiv>
                </BottomDiv>
              </CalendarDropdown>
            )}
          </Dropdown>
        </>
      );
    },
    [
      alignment,
      buttonHeight,
      dropdownTopOffset,
      handleClick,
      handleTimeChange,
      isCalendarOpen,
      onCancelSnooze,
      onClickSnooze,
      openDropdownId,
      position,
      selectedDate,
      selectedTime,
      snoozeMenuItems
    ]
  );

  // List of all notifications
  const renderNotificationList = useMemo(() => {
    if (!filteredNotifications) return null;
    return filteredNotifications.map((item, index: number) => {
      if (!buttonRef.current[index]) {
        buttonRef.current[index] = React.createRef<HTMLDivElement>();
      }
      if (!mobileDropdownTriggerRefs.current[index]) {
        mobileDropdownTriggerRefs.current[index] = React.createRef<HTMLDivElement>();
      }
      const currentProject = item?.taskId ? item?.task?.project : null;
      return (
        <SwipeRowContainer
          key={item.id}
          className='swipe-row-no-animation'
          style={{
            animation: 'none',
            transition: 'none',
            // Only add animation to the item being deleted
            ...(mobile && deletingId === item.id
              ? {
                  transform: 'translateX(0)',
                  opacity: 1
                }
              : {})
          }}>
          {/* actions to be shown on swipe */}
          <SwipeAction>
            <div>{renderInboxButton(item, index, false)}</div>
          </SwipeAction>
          {/* Sliding content */}
          <SwipeMsgCard
            style={{
              willChange: 'transform, opacity',
              transform:
                mobile && deletingId === item.id
                  ? 'translateX(-100vw)' // Slide out left when being deleted
                  : swipedItemId === item.id && touchStartX && touchEndX
                  ? `translateX(${Math.max(-146, Math.min(0, touchEndX - touchStartX))}px)` // Track movement in left direction
                  : 'translateX(0)', // No transform for normal state
              opacity: mobile && deletingId === item.id ? 0 : 1,
              // Only apply transitions when needed and not during rearrangement
              transition: isRearranging
                ? 'none'
                : mobile && deletingId === item.id
                ? 'transform 0.2s cubic-bezier(0.22, 0.61, 0.36, 1), opacity 0.3s cubic-bezier(0.22, 0.61, 0.36, 1)'
                : swipedItemId === item.id
                ? 'none' // No transition while actively swiping to prevent jerking
                : 'transform 0.2s cubic-bezier(0.22, 0.61, 0.36, 1)', // Add smooth transition for release and resetting
              // Prevent any animation when rearranging
              animation: isRearranging ? 'none' : undefined
            }}>
            <Dropdown
              isRemoveMaxHeight={true}
              isMinWidth={148}
              content={
                <MSG
                  key={item?.id}
                  isRead={item?.isRead === true}
                  onClick={(e) => {
                    if (!hasMoved && (swipedItemId || !mobile)) {
                      onClickInboxItem(e, item, index);
                    }
                  }}
                  isIconActive={item?.id === openDropdownId}
                  onMouseEnter={() => setHoveredItemId(item.id)}
                  onMouseLeave={() => {
                    setHoveredItemId(null);
                  }}
                  // Touch Events
                  onTouchStart={(e) => {
                    handleTouchStart(e, item.id);
                  }}
                  onTouchMove={(e) => {
                    handleTouchMove(e);
                  }}
                  onTouchEnd={(e) => {
                    handleTouchEnd(e);
                  }}>
                  <MSGdetail>
                    <AvatarDot>
                      <IconView className='pointer'>
                        <SVGIcon
                          name='active-point-icon'
                          width='5'
                          height='6'
                          viewBox='0 0 5 6'
                          fill='none'
                          className='dot-icon'
                        />
                      </IconView>
                      {/* github icon */}
                      {item?.senderId === 'github' ? (
                        <SVGIcon
                          name={getSvgIcon()}
                          width='28'
                          height='28'
                          viewBox='0 0 28 28'
                          className='github-icon'
                        />
                      ) : item?.senderId === 'sentry' ? (
                        <SVGIcon
                          name='sentry-icon'
                          width='28'
                          height='28'
                          viewBox='0 0 32 32'
                          className='github-icon'
                        />
                      ) : (
                        <Avatar
                          imgSrc={item?.user?.profile_photo || ''}
                          name={item?.user?.name || ''}
                          size={26}
                          isThinBorder={true}
                          classname='avatar'
                        />
                      )}
                      <IconView>{renderProfileIcons(item?.type, item?.title)}</IconView>
                    </AvatarDot>
                    <MSGblock>
                      <Read>
                        <MSGtitle>
                          {item?.title}
                          {/* for mobile view */}
                          <span className='dot-icon'>・</span>
                          <DateSection>{moment(item?.date).fromNow()}</DateSection>
                        </MSGtitle>
                        {item?.type === NOTIFICATION_TYPE.TASK && <MSGtext>{item?.description}</MSGtext>}
                      </Read>
                      {item?.type === NOTIFICATION_TYPE.COMMENT && (
                        <Desc
                          isImage={
                            item?.description?.includes('figma-preview-image') ||
                            item?.description?.includes('screen-recording-custom-main-div') ||
                            item?.description?.includes('figma-link-div') ||
                            item?.description?.includes('prnt-preview-main-div') ||
                            item?.description?.includes('<img') ||
                            item?.description?.includes('youtube-preview-main-div')
                          }>
                          <RenderInboxHtml htmlString={item?.description} />
                        </Desc>
                      )}
                    </MSGblock>
                  </MSGdetail>
                  {/* for Desktop view */}
                  <MSGtime>
                    <MSGsubtext>{moment(item?.createdTime).fromNow()}</MSGsubtext>
                    <Bottom>{renderInboxButton(item, index, false)}</Bottom>
                  </MSGtime>
                </MSG>
              }
              trigger='contextmenu'>
              <DropdownItem
                label='Mark as seen'
                iconName='true-icon'
                iconTone='stroke'
                onClick={() => onClickReadIcon(item, index)}
              />
              <DropdownItem
                label='Archive'
                iconName='bin-icon'
                iconTone='stroke'
                onClick={() => onClickDeleteIcon(item)}
              />

              {renderSnoozeDropdown(item, true)}

              {currentProject && item?.task && <DropdownDivider />}
              {currentProject &&
                currentProject?.statusEnable &&
                currentProject?.statusData?.length > 0 &&
                item?.task && (
                  <Dropdown
                    isMinWidth={148}
                    content={
                      <ItemDiv>
                        <DropdownItem label='Status' iconName='status-icon' iconSize={16} iconTone='stroke' />
                      </ItemDiv>
                    }
                    trigger='hover'>
                    {currentProject?.statusData.map((status, index) => {
                      const currentStatus =
                        currentProject?.statusData.find((s) => s?.['_id'] === item?.task?.statusId) ||
                        currentProject?.statusData?.find((s) => s?.Default);
                      return (
                        <DropdownItem
                          key={index}
                          label={status.Name}
                          onClick={() => onClickUpdateStatus(item?.task!, status, currentStatus!)}
                          iconName={renderStatusIconName(status.Type)}
                        />
                      );
                    })}
                  </Dropdown>
                )}
              {currentProject &&
                currentProject?.isGroupEnabled &&
                currentProject?.taskGroups?.length > 0 &&
                item?.task && (
                  <Dropdown
                    isMinWidth={148}
                    content={
                      <ItemDiv>
                        <DropdownItem
                          label='Group'
                          iconName='contextmenu-group-icon'
                          iconSize={16}
                          iconViewBox='0 0 18 18'
                          iconTone='stroke'
                        />
                      </ItemDiv>
                    }
                    trigger='hover'>
                    {currentProject?.taskGroups?.map((group) => (
                      <DropdownItem
                        key={group.index}
                        label={group.name}
                        onClick={() => {
                          onClickGroup(item?.task!, group);
                        }}
                      />
                    ))}
                  </Dropdown>
                )}
              {currentProject && currentProject?.priority?.enabled && (
                <Dropdown
                  isMinWidth={148}
                  content={
                    <ItemDiv>
                      <DropdownItem label='Priority' iconName='Priority-High-icon' iconSize={16} iconTone='fill' />
                    </ItemDiv>
                  }
                  trigger='hover'>
                  {menuItems.map((priority, index) => (
                    <DropdownItem
                      key={index}
                      label={priority.label}
                      onClick={() => onClickUpdatePriority(item?.task!, priority.key)}
                      iconName={priority.icon}
                    />
                  ))}
                </Dropdown>
              )}
              {currentProject && currentProject?.users && item?.task && (
                <AssignBoxV2
                  projectUsers={currentProject?.users}
                  currentTask={item?.task}
                  isContextMenu={true}
                  isMultiAssignee={currentProject?.multiAssignee}
                  isRecurringTask={isRecurringTask}
                  isTemplateProject={isTemplateProject}
                />
              )}

              {currentProject && item?.task && (
                <Dropdown
                  isMinWidth={148}
                  trigger='hover'
                  isRemoveMaxHeight={true}
                  content={
                    <ItemDiv>
                      <DropdownItem label='Due date' iconName='secound-calendar-icon' iconSize={16} />
                    </ItemDiv>
                  }>
                  <CalendarDropdownMenuV2
                    isRecurringTask={isRecurringTask}
                    isCustomContextMenu={true}
                    taskData={item?.task}
                    calendarDate={calanderDate}
                    setCalendarDate={setCalendarDate}
                  />
                </Dropdown>
              )}
              {/* message notification item */}
              {/* <DropdownItem label='Reactions' iconName='emoji-icon' iconViewBox='0 0 16 16' />
              <DropdownItem label='Reply' iconName='reply-icon' /> */}
            </Dropdown>
          </SwipeMsgCard>
        </SwipeRowContainer>
      );
    });
  }, [
    filteredNotifications,
    mobile,
    deletingId,
    renderInboxButton,
    swipedItemId,
    touchStartX,
    touchEndX,
    isRearranging,
    openDropdownId,
    getSvgIcon,
    renderProfileIcons,
    renderSnoozeDropdown,
    isRecurringTask,
    isTemplateProject,
    calanderDate,
    hasMoved,
    onClickInboxItem,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    onClickReadIcon,
    onClickDeleteIcon,
    onClickUpdateStatus,
    onClickGroup,
    onClickUpdatePriority
  ]);

  // Render desktop app notification card
  const renderDesktopNotificationCard = useMemo(() => {
    return (
      <NotificationCard>
        <MSGdetail className='deskTopNotification-card'>
          <AvatarDot>
            <DesktopIcon>
              <SVGIcon name='desktop-icon' width='16' height='16' viewBox='0 0 18 18' className='desktop-icon' />
            </DesktopIcon>
          </AvatarDot>
          <RightContent>
            <Description>
              <MSGtitle className='desktopNotification-card'>Install Teamcamp to Your Desktop!</MSGtitle>
              <MSGtext className='desktopNotification-card'>
                Install the Teamcamp desktop app now and take your work to the next level with a faster,
                distraction-free experience.
              </MSGtext>
              <BottomButton>
                <ButtonV2
                  title={'Get desktop app'}
                  variant={BUTTON_TYPE.SECONDARY}
                  size='small'
                  onClick={() => window.open('https://www.teamcamp.app/download', '_blank')}
                />
                <p onClick={onDismissDesktopNotification}>No, Thanks</p>
              </BottomButton>
            </Description>
            <DesktopImage>
              {/* image for mac */}
              <img src={desktopappmac} alt='img' width={158} height={100} className='image' />
              {/* image for window */}
              {/* <img src={desktopappwindow} alt='img' width={158} height={100} className='image' /> */}
            </DesktopImage>
          </RightContent>
        </MSGdetail>
      </NotificationCard>
    );
  }, [onDismissDesktopNotification]);

  const renderInboxButtonCheck = useCallback(() => {
    if (selectedTask && typeof selectedTaskIndex === 'number') {
      return renderInboxButton(selectedTask, selectedTaskIndex, true);
    }
  }, [renderInboxButton, selectedTask, selectedTaskIndex]);

  const renderMoreMenu = useCallback(() => {
    return (
      <Dropdown
        modalTitle='Manage Notifications'
        activeClassName='active-state'
        content={
          <RightSide>
            <SVGIcon
              name='three-dots-horizontal-icon'
              width='16'
              height='16'
              viewBox='0 0 18 18'
              fill='var(--text-secondary)'
            />
          </RightSide>
        }
        trigger='click'>
        {menuInboxArchiveItems.map((item) => {
          return <DropdownItem key={item?.key} label={item?.label} onClick={() => OpenDeleteModel()} />;
        })}
      </Dropdown>
    );
  }, [OpenDeleteModel]);

  return (
    <>
      <AppLayout isInbox={true} Inbox={true} isTaskDetailPreviewOpen={isTaskDetailOpen}>
        {!mobile ? (
          <MainHeader isScrollPage={isScrollPage}>
            <HeaderInbox>
              <LeftSide>
                <Heading>
                  <SVGIcon
                    name='inbox-header-icon'
                    width='24'
                    height='19'
                    viewBox='0 0 24 19'
                    fill='none'
                    className='inbox-header-icon'
                  />
                  <Title>Inbox</Title>
                </Heading>
              </LeftSide>
              {notifications?.length > 0 && (
                <>
                  <Div>
                    <Menu>
                      <Buttons
                        isActive={filterType === INBOX_FILTER_TYPE.ALL || !filterType}
                        onClick={() => inboxTabChange(INBOX_FILTER_TYPE.ALL)}>
                        All
                      </Buttons>
                      <Buttons
                        isActive={filterType === INBOX_FILTER_TYPE.ASSIGN_TO_ME}
                        onClick={() => inboxTabChange(INBOX_FILTER_TYPE.ASSIGN_TO_ME)}>
                        Assigned to me
                      </Buttons>

                      <Buttons
                        isActive={filterType === INBOX_FILTER_TYPE.MENTION}
                        onClick={() => inboxTabChange(INBOX_FILTER_TYPE.MENTION)}>
                        @Mentioned
                      </Buttons>
                    </Menu>
                    <Dropdiv>{renderMoreMenu()}</Dropdiv>
                  </Div>
                </>
              )}
            </HeaderInbox>
          </MainHeader>
        ) : (
          <ResponsiveHeader
            isInbox={true}
            Title='Inbox'
            leftElement={
              <>
                <Dropdiv>{renderMoreMenu()}</Dropdiv>
                <Dropdown
                  modalTitle='Filters'
                  content={
                    <RightSide>
                      <SVGIcon
                        name='filter-icon'
                        width='20'
                        height='20'
                        viewBox='0 0 18 18'
                        fill='var(--text-secondary)'
                      />
                    </RightSide>
                  }
                  trigger='click'>
                  {menuInboxFilterItems.map((item) => {
                    return (
                      <DropdownItem
                        key={item?.key}
                        label={item?.label}
                        isSelected={filterType ? item?.key === filterType : item?.key === INBOX_FILTER_TYPE.ALL}
                        onClick={() => {
                          inboxTabChange(item?.key);
                          notificationStore.setFilterType(item?.key);
                        }}
                      />
                    );
                  })}
                </Dropdown>
              </>
            }
          />
        )}

        {/* Loading state */}
        {loading && filteredNotifications?.length === 0 && <InboxLoading />}

        {/* Emptystate */}
        {!loading &&
          filteredNotifications?.length === 0 &&
          !isShowOverdueCard &&
          !isShowDesktopNotification &&
          !(isShowNotificationCard && getCurrentDomain() === 'dash.teamcamp.app') && (
            <Empty>
              <EmptyState
                header='Your inbox is empty for now'
                // eslint-disable-next-line max-len
                title={`This is where you'll receive notifications for all types of activity. Enjoy your clutter-free inbox!`}
                hideButton={true}
                image={getImageSource()}
                width={330}
              />
            </Empty>
          )}
        {(filteredNotifications?.length > 0 ||
          isShowOverdueCard ||
          isShowNotificationCard ||
          isShowDesktopNotification) && (
          <InboxMSG>
            {/* Desktop app notification card */}
            {isShowDesktopNotification &&
              (!loading || filteredNotifications?.length > 0) &&
              renderDesktopNotificationCard}

            {isShowOverdueCard &&
              (!loading || filteredNotifications?.length > 0) &&
              renderCard({
                iconName: 'overdue-icon',
                title: `You have ${overDueTasks} overdue task!`,
                text: `It's good to be on schedule. Try to finish your overdue task or reschedule it.`,
                buttonTitle: 'View My Tasks',
                buttonAction: () => history.push(ROUTES.MYTASK),
                dismissAction: onClickDismiss,
                className: 'overdue-card'
              })}

            {isShowNotificationCard &&
              (!loading || filteredNotifications?.length > 0) &&
              renderCard({
                iconName: 'notification-inbox',
                title: 'Enable notifications and Stay in the Loop!',
                // eslint-disable-next-line max-len
                text: 'Enable notifications to receive real-time updates on task progress, new assignments, and important messages',
                buttonTitle: 'Enable Notifications',
                buttonAction: onEnableNotification,
                dismissAction: onClickNoEnableNotification,
                className: 'notification-card'
              })}

            {renderNotificationList}
          </InboxMSG>
        )}
      </AppLayout>
      <ModalCustom open={deleteModelOpen} onClose={closeDeleteModel} width={337} isZindex={true}>
        <DeleteModal
          onClose={closeDeleteModel}
          loading={buttonLoading}
          isArchive={true}
          onOk={clearAllMessages}
          modalTitle='Archive all notifications?'
          description='Are you sure you want to archive all notifications?'
        />
      </ModalCustom>
      <ModalCustom open={isOpenConfirmationModal} onClose={closeConfirmationModal} width={334}>
        <ConfirmationModal
          loading={confirmationLoading === 'ok'}
          cancelLoading={confirmationLoading === 'cancel'}
          onOk={onClickConfirm}
          onNo={onClickNo}
          onClose={closeConfirmationModal}
          modalTitle='Uncompleted Subtasks'
          description='Do you want to complete all these subtasks?'
        />
      </ModalCustom>
      {/* bottom navigation bar */}
      <BottomNavigation />

      {!isEmpty(selectedTask?.taskId) && !isEmpty(selectedTask?.projectId) && (
        <>
          {isTaskDetailOpen && (
            <>
              <Overlay onClick={handleCloseTaskDetail}></Overlay>
              <div>
                <Content>
                  <PreviewSection>
                    <DetailPreview>
                      <TaskDetailPreview
                        taskId={selectedTask?.taskId || ''}
                        projectId={selectedTask?.projectId || ''}
                        handleCloseTaskDetail={handleCloseTaskDetail}
                      />
                    </DetailPreview>
                    <ActionSection>
                      <InboxPreviewAction>
                        <ActionIcon
                          onClick={() => handleArrowClick('Backward')}
                          isDisabled={taskDetails?.id !== selectedTask?.taskId || buttonDisable.backward}>
                          <SVGIcon
                            name='left-arrow-icon'
                            width='16'
                            height='16'
                            viewBox='0 0 16 16'
                            fill='none'
                            className='upper-icon'
                          />
                        </ActionIcon>
                        <ActionIcon
                          onClick={() => handleArrowClick('Forward')}
                          isDisabled={taskDetails?.id !== selectedTask?.taskId || buttonDisable.forward}>
                          <SVGIcon
                            name='left-arrow-icon'
                            width='16'
                            height='16'
                            viewBox='0 0 16 16'
                            fill='none'
                            className='down-icon'
                          />
                        </ActionIcon>
                      </InboxPreviewAction>
                      {renderInboxButtonCheck()}
                    </ActionSection>
                  </PreviewSection>
                </Content>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default observer(Inbox);
